import {

  queryShopHomeLink,
  addShopHomeLink,
  updateShopHomeLink,
  deleteShopHomeLink
} from '@/api/sys.homeLink'

export default {
  namespaced: true,
  actions: {

    queryShopHomeLink ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return queryShopHomeLink(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    addShopHomeLink ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return addShopHomeLink(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateShopHomeLink ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return updateShopHomeLink(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    deleteShopHomeLink ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return deleteShopHomeLink(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }

  }
}
